import React from 'react';
export function Footer() {
  return <footer className="py-8 border-t border-white/5 bg-[#0A0A0F] text-center" data-id="element-35">
      <div className="container mx-auto px-4" data-id="element-36">
        <p className="text-slate-500 text-sm" data-id="element-37">
          &copy; {new Date().getFullYear()} Método Cero Ruido. Todos los
          derechos reservados.
        </p>
        <p className="text-slate-600 text-xs mt-2 max-w-2xl mx-auto" data-id="element-38">
          Este producto no sustituye el consejo médico profesional, diagnóstico
          o tratamiento. Si tienes una condición médica, consulta siempre a tu
          médico u otro proveedor de salud calificado.
        </p>
      </div>
    </footer>;
}